import { createApp } from "vue";
import App from "./App.vue";
import "./assets/main.css";
import router from "./router";

// ✅ Redirección solo para el subdominio (hash mode)
// Nota: el server NO puede redirigir a "#", así que lo hacemos aquí.
(function redirectSubdomainToHogar() {
  const host = window.location.hostname;

  // si estás en el subdominio del hogar
  if (host === "aseguratuhogar.inbros.mx") {
    const hash = window.location.hash; // ejemplo: "#/CotizadorHogar" o "#/"

    // Si no hay hash, o está en "#/" (home), manda al cotizador
    if (!hash || hash === "#" || hash === "#/" || hash === "#/") {
      // 👇 IMPORTANTE: usa exactamente la ruta que tengas en el router
      window.location.replace("/#/CotizadorHogar");
      // si tu ruta es minúscula:
      // window.location.replace("/#/cotizadorhogar");
    }
  }
})();

createApp(App).use(router).mount("#app");
